import React from 'react';

const PaginationControls = ({ paginationProps }) => {
    const {
        totalPages,
        currentPage,
        recordsPerPage,
        setRecordsPerPage,
        nextPage,
        prevPage,
        totalRecords,
        firstRecordIndex,
        lastRecordIndex,
    } = paginationProps;

    if (totalRecords === 0) {
        return null; // Don't show controls if there's no data
    }

    return (
        <div className="pagination-controls-container">
            <div className="pagination-select-wrapper">
                <label htmlFor="records-per-page">Rows per page:</label>
                <select
                    id="records-per-page"
                    value={recordsPerPage}
                    onChange={(e) => setRecordsPerPage(e.target.value)}
                >
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div>
            <div className="pagination-info">
                Showing {firstRecordIndex} - {lastRecordIndex} of {totalRecords}
            </div>
            <div className="pagination-nav">
                <button onClick={prevPage} disabled={currentPage === 1} title="Previous Page">
                    &lt;
                </button>
                <span>Page {currentPage} of {totalPages}</span>
                <button onClick={nextPage} disabled={currentPage === totalPages} title="Next Page">
                    &gt;
                </button>
            </div>
        </div>
    );
};

export default PaginationControls;